import { Helmet } from 'react-helmet';
import { siteConfig } from '../config.js';
import SectionA from '../components/ContactSectionA.js';
import Header from '../components/Header.js';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact | {siteConfig.title}</title>
        <meta name="description" content={siteConfig.metaDescription} />
      </Helmet>

      <Header config={siteConfig} />
        <SectionA />  
      <PreFooter />
      <Footer/>
    </>
  );
}
